import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { IndividualScheduleCalendarHeaderRow, IndividualScheduleCalendarRow } from 'components/Calendar'
import { getCalendarArray } from 'lib/calendar'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { endOfMonth, startOfMonth } from 'date-fns'

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  individualSettingDates: Date[]
  selectSettingDate: (date: Date) => void
  handleCaution: (flag: boolean) => void
}

const IndividualScheduleCalendar: FC<Props> = (props) => {
  const { activeDates, businessDays, currentMonth, handleCaution, individualSettingDates, selectSettingDate } = props

  const calendar = getCalendarArray(startOfMonth(currentMonth), endOfMonth(currentMonth))

  return (
    <table className={styles.table}>
      <thead>
        <IndividualScheduleCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <IndividualScheduleCalendarRow
            key={rowNum}
            activeDates={activeDates}
            businessDays={businessDays}
            currentMonth={currentMonth}
            handleCaution={handleCaution}
            individualSettingDates={individualSettingDates}
            selectSettingDate={selectSettingDate}
            row={row}
          />
        ))}
      </tbody>
    </table>
  )
}

export default IndividualScheduleCalendar
